import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
// import './modules/preload'
import './modules/smoothScroll';
import './modules/swiper'
import './modules/covid19Modal';
import './modules/telephoneModal';
import './modules/hamburger';
import './modules/currentMenu'

new WOW().init();